import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Find the root DOM node
const container = document.getElementById("root");

// Create a root and render the app
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
